module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gRuLn"))).then(() => parcelRequire('hEqeo'));